import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    width: 24,
    height: 24,
    fill: "transparent"
  }
}));

const IcMenu = (props) => {

  const classes = blockStyles();
  const { className } = props;

  return (
    <SvgIcon className = { clsx(classes.root, className) }
             viewBox = { "0 0 24 24" } >
      <path d="M4 7L20 7" stroke="#1A1919" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 12L20 12" stroke="#1A1919" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4 17L20 17" stroke="#1A1919" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  );
}

export default IcMenu;
